import { createContext, useContext } from 'react';

export const ConversationContext = createContext({
  conversationId: '',
  modelInfo: null,
  isMcpShare: false,
});

export const useConversationContext = () => {
  return useContext(ConversationContext);
};


export const MessageContext = createContext({
  conversationId: '',
  msg_id: '',
  loading: false,
  typing: false,
  code_info: {},
});

export const useMessageContext = () => {
  return useContext(MessageContext);
};


// 注：只可用于左侧，及右侧卡片中
export const McpItemContext = createContext({
  isAITyping: false,
});

export const useMcpItemContext = () => {
  return useContext(McpItemContext);
};